// eslint-disable-next-line max-len
export const YOUTUBE_LINK_REGEX = '^(?:https?:\\/\\/)?(?:m\\.|www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:embed\\/|v\\/|watch\\?v=|watch\\?.+&v=))((\\w|-){11})(\\?\\S*)?$';

export function getYoutubeVideoId(url) {
  try {
    let videoId;
    const anchor = document.createElement('a');
    anchor.href = url;
    // Если есть query-параметры, то ищем в них. Иначе берем всю часть после слеша.
    if (anchor.search) {
      const queryStrings = anchor.search.substring(1);
      const urlParams = new URLSearchParams(queryStrings);
      videoId = urlParams.get('v');
    } else {
      videoId = anchor.pathname.substring(1);
    }
    return videoId;
  } catch {
    throw new Error('Ошибка при получении ID видео');
  }
}

export function getYoutubeEmbedLink(url) {
  try {
    const videoId = getYoutubeVideoId(url);
    return `https://www.youtube.com/embed/${videoId}`;
  } catch {
    throw new Error('Ошибка при вставке видео');
  }
}
